<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12" lg="6">
        <v-text-field
          v-model="form.name"
          :error-messages="$page.props.errors.name"
          label="Name"
          outlined
        />
      </v-col>
      <v-col cols="12" lg="6">
        <v-text-field
          v-model="form.email"
          :error-messages="$page.props.errors.email"
          label="Email"
          outlined
        />
      </v-col>
      <v-col cols="12" lg="6">
        <v-text-field
          v-model="form.phone"
          :error-messages="$page.props.errors.phone"
          label="Phone"
          outlined
        />
      </v-col>
      <v-col cols="12" lg="6">
        <v-text-field
          v-model="form.address"
          :error-messages="$page.props.errors.address"
          label="Address"
          outlined
        />
      </v-col>
      <v-col cols="12" lg="6">
        <v-text-field
          v-model="form.city"
          :error-messages="$page.props.errors.city"
          label="City"
          outlined
        />
      </v-col>
      <v-col cols="12" lg="6">
        <v-text-field
          v-model="form.postal_code"
          :error-messages="$page.props.errors.postal_code"
          label="Postal code"
          outlined
        />
      </v-col>
      <v-col cols="12" lg="6">
        <v-text-field
          v-model="form.region"
          :error-messages="$page.props.errors.region"
          label="Province/State"
          outlined
        />
      </v-col>
      <v-col cols="12" lg="6">
        <v-select
          v-model="form.country"
          :error-messages="$page.props.errors.country"
          :items="countries"
          label="Country"
          outlined
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
   name: 'OrganizationForm',

   props: {

   },

   data () {
      return {
         form: this.$inertia.form({
            name: null,
            email: null,
            phone: null,
            address: null,
            city: null,
            postal_code: null,
            region: null,
            country: null
         }),
         countries: [
            { value: 'CA', text: 'Canada' },
            { value: 'US', text: 'United States' },
         ],
      }
   }
}
</script>
